import { Injectable } from '@angular/core';
import { JobStub } from '../core-data-model/Job/JobStub.model';
import { Job } from '../core-data-model/Job.model';
import {
    OrderedSet,
    StandardMaxOrderedSetSize
} from '../core-data-model/OrderedSet';
import { UserProfileSettingsService } from '../system-services/UserProfileSettings/UserProfileSettings.service';

@Injectable({ providedIn: 'root' })
export class JobsDataService {
    mostRecentJobs: OrderedSet<JobStub> = new OrderedSet<JobStub>(
        [],
        StandardMaxOrderedSetSize + 1,
        StandardMaxOrderedSetSize
    );

    constructor(
        private userProfileSettingsService: UserProfileSettingsService
    ) {
        this.mostRecentJobs =
            userProfileSettingsService.companySpecificSetting.recentlySelectedJobs;
    }

    addToMostRecentJobs(job: Job) {
        this.mostRecentJobs.updateArrayTop(
            job,
            (arrayElem, thisElem) => arrayElem.id === thisElem.id
        );
        this.userProfileSettingsService.updateMostRecentJobs(
            this.mostRecentJobs.orderedArray
        );
    }

    removeFromMostRecentJobs(jobId: string): void {
        const removed = !!this.mostRecentJobs.removeElement(
            (entry) => entry.id === jobId
        );
        if (removed) {
            this.userProfileSettingsService.updateMostRecentJobs(
                this.mostRecentJobs.orderedArray
            );
        }
    }

    jobBeingArchived(jobId: string) {
        this.mostRecentJobs.removeElement(
            (arrayElem) => arrayElem.id === jobId
        );
        this.userProfileSettingsService.updateMostRecentJobs(
            this.mostRecentJobs.orderedArray
        );
    }
}
